import { createSlice } from "@reduxjs/toolkit";
import { CategoryList, hardwareList } from "../../Components/Data";


const initialState = {
    hardware: hardwareList ?? [],
    loading: false,
    categories: CategoryList ?? [],
    cart: []
};

export const dataListsSlice = createSlice({
    name: "dataList",
    initialState,
    reducers: {
        dataListRequested: (dataList,) => {
            dataList.loading = true;
        },
        dataListSucess: (dataList, action) => {
            dataList.hardware = action.payload;
            dataList.loading = false;
        },
        addcart: (dataList, action) => {
            if (dataList.cart.find(e => e?.id == action.payload?.id)) {
                const updatedCart = dataList.cart.map(item =>
                    item.id === action.payload?.id ? { ...item, qnt: action.payload.qnt ?? 1 } : item
                );

                dataList.cart = updatedCart;

            } else {
                dataList.cart.push(action.payload)
            }
            dataList.loading = false;
        },
        removeCart: (dataList, action) => {
            dataList.cart = dataList.cart?.filter(e => e?.id != action.payload?.id);
            dataList.loading = false;
        },
        removeAllCart: (dataList, ) => {
            dataList.cart = [];
            dataList.loading = false;
        },
        dataListFailure: (dataList,) => {
            dataList.loading = false;
        },
    },
});

export const { dataListRequested, dataListSucess, dataListFailure, addcart, removeCart, removeAllCart } = dataListsSlice.actions;
export default dataListsSlice.reducer;
